import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  /** Full page centered spinner vs inline content spinner */
  fullPage?: boolean;
  /** Message shown below the spinner */
  message?: string;
  /** Size of the spinner icon */
  size?: 'sm' | 'md' | 'lg';
}

const sizes = {
  sm: 'h-5 w-5',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

export function LoadingSpinner({ fullPage = false, message, size = 'md' }: LoadingSpinnerProps) {
  if (fullPage) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3">
        <Loader2 className={`${sizes[size]} animate-spin text-wire3-green`} />
        {message && (
          <p className="text-sm font-medium text-gray-400 dark:text-gray-500">{message}</p>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12">
      <Loader2 className={`${sizes[size]} animate-spin text-wire3-green`} />
      {message && (
        <p className="text-sm font-medium text-gray-400 dark:text-gray-500">{message}</p>
      )}
    </div>
  );
}
